exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkpoints[data-v-7237ba98] {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n", ""]);

